import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Quality } from '../models';
import { BaseEditService } from './base';

@Injectable({
  providedIn: 'root',
})
export class QualityService extends BaseEditService<Quality, Quality> {
  readonly qualitySelected$ = new Subject<string>();

  // Fired after the Details form saves: the weaving screens stay open on save and the
  // host re-reads its model so the whole screen refreshes in place (R5, Steve 2026-09-09).
  public refreshDetails = new Subject<void>();

  constructor() {
    super('Quality', $localize`Quality`);
  }
}
